import { VideoBackgrounds } from './video-backgrounds.mjs';

window.VideoBackgrounds = VideoBackgrounds;
